export default __webpack_public_path__ + "static/media/region_map.a6cbfe1d.png";